import EsusView from 'components/esus/EsusView'

export default function FichaVacinacaoView() {
  return <EsusView url='/pec/user/cds/fichaVacinacao' />
}
